var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style['data-item'], { [_vm.$style['data-item--nowrap']]: _vm.nowrap }]},[(_vm.label)?_c('span',{class:_vm.$style['data-item__caption']},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._t("default",function(){return [_c('span',{class:_vm.$style['data-item__content']},[_vm._v(_vm._s(_vm.content))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }